class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.closeButton = this.querySelector('[data-close-modal]');

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );

    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );

    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.close.bind(this)
      );
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer && this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();

    const details = event.target.closest('details');
    if (!details) return;

    details.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('page-layout__overlay')) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer) return;

    if (this.dataset.documentClass) {
      document.documentElement.classList.add(this.dataset.documentClass);
    }

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);

    const details = event.target.closest('details');
    if (!details) return;

    details.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    setTimeout(() => {
      const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]');
      const focusInput = this.detailsContainer.querySelector('input:not([type="hidden"])');

      if (focusContainer) {
        trapFocus(focusContainer, focusInput || focusContainer);
      }
    }, 100);
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) return;

    if (this.dataset.documentClass) {
      document.documentElement.classList.remove(this.dataset.documentClass);
    }

    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');

    if (this.onBodyClickEvent) {
      document.body.removeEventListener('click', this.onBodyClickEvent);
    }
  }
}

customElements.define('details-modal', DetailsModal);